import { requestHumanVerification } from '../features/auth/humanVerificationStore';
import { isChallengeRequired } from './otpGuardResponse';

const JSON_HEADERS = { 'Content-Type': 'application/json' };
const TURNSTILE_TOKEN_FIELD = 'turnstile_token';

type Init = { headers?: Record<string, string>; signal?: AbortSignal };

const readJson = async (response: Response): Promise<unknown> => {
  try {
    return await response.clone().json();
  } catch {
    return null;
  }
};

/**
 * POST JSON with credentials; if the backend answers `428 challenge_required`, ask the
 * user to prove they are human (HumanVerificationDialog) and re-POST once with the token.
 * Anything else — including a second 428 or a cancelled dialog — is returned as-is so the
 * caller shows the backend's sentence.
 */
export async function postJsonWithChallenge(
  url: string,
  body: Record<string, unknown>,
  init: Init = {},
): Promise<Response> {
  const post = (payload: Record<string, unknown>) =>
    fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: { ...JSON_HEADERS, ...(init.headers ?? {}) },
      body: JSON.stringify(payload),
      signal: init.signal,
    });
  const first = await post(body);
  if (!isChallengeRequired(first.status, await readJson(first))) return first;
  let token: string;
  try {
    token = await requestHumanVerification();
  } catch {
    return first;
  }
  return post({ ...body, [TURNSTILE_TOKEN_FIELD]: token });
}
